<template>
        <div class="user-password-dialog modal modal-fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('passwordChange') }}</h5>
                        <button type="button" class="btn-close" @click="close" data-dismiss="modal" aria-label="Close" />
                    </div>
                    <div class="modal-body">
                        <form>
                            <input v-bind:class='["form-control", danger]' type="password" v-model="model.password">
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                            {{ $t('close') }}
                        </button>
                        <button type="button" class="btn btn-primary" @click="setPassword" >
                            {{ $t('confirm') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import userApi from "../../../api/server/user";

export default {
    name: "modal",
    notifications: {
        showSuccess: { 
            title: 'Password change',
            message: 'Password succesfully changed!',
            type: 'success'
        },
        showError: { 
            title: 'Password change',
            message: 'Your password is too short!',
            type: 'error'
        }
    },
    methods: {
        close() {
            this.$emit("close");;
            this.danger = "";
            this.model.password = "";
        },
        async setPassword() {
            if(this.model.password.length > 3) {
                await userApi.setPassword(this.$parent.userToChangePasswordId, this.model);
                this.showSuccess();
                this.$emit("close");
                this.danger = "";
                this.model.password = "";
            } else {
                this.showError();
                this.danger = "danger";
            }
        },
    },
    data() {
        return {
            danger: "",
            model: {
                password: ""
            }
        };
    },
};
</script>